import { ChangeDetectionStrategy, Component, effect, input, model, output, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DtoChangedDetection } from '../../abstract';

@Component({
  selector: 'aura-edit-wrapper',
  exportAs: 'auraEditWrapper',
  imports: [MatButton, MatIcon, MatTooltipModule, MatDividerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './form-edit-wrapper.component.html',
})
export class AuraEditWrapperComponent<TDto> {
  title = input<string>();
  isEditing = model<boolean>(false);
  isAllowedToEdit = input<boolean>(true);
  showDivider = input<boolean>(false);
  saved = output<TDto | null>();

  showEditingState = signal<boolean>(false);
  currentDto = signal<TDto | null>(null);
  isChanged = signal(false);
  isValid = signal(false);

  constructor() {
    effect(() => {
      if (this.isEditing() && this.isAllowedToEdit()) {
        this.showEditingState.set(true);
      } else {
        this.showEditingState.set(false);
      }
    });
  }

  toggleEditing(): void {
    this.isEditing.update((v) => !v);
  }

  save(): void {
    const dto = this.currentDto();
    if (this.isValid() && this.isChanged()) {
      this.saved.emit(dto);
    }
  }

  onValidityChanged(valid: boolean): void {
    this.isValid.set(valid);
  }

  onDtoChanged(event: DtoChangedDetection<TDto>): void {
    if (event.dto !== undefined) {
      this.currentDto.set(event.dto);
    }
    this.isChanged.set(event.changed);
  }
}
